import React from 'react';
import './about.css';
import angleBracketsLogo from '../../assets/angleBracketsLogo.png';
import { FaAward } from 'react-icons/fa';
import { FiUsers } from 'react-icons/fi';
import { BiMap } from 'react-icons/bi';

export default function About() {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img src={angleBracketsLogo} alt='About Image' />
          </div>
        </div>
        <div className='about__content'>
          <div className='about__cards'>
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <small>3+ Years Working</small>
            </article>
            <article className='about__card'>
              <FiUsers className='about__icon' />
              <h5>Companies </h5>
              <small>2+
              </small>
            </article>
            <a className='about__card' href="https://www.google.com/maps/place/Tirana/@41.3309822,15.3704203,1324621m/data=!3m1!1e3!4m5!3m4!1s0x1350310470fac5db:0x40092af10653720!8m2!3d41.3275459!4d19.8186982" target="_blank">
              <BiMap className='about__icon' />
              <h5 >Location</h5>
              <small>Tirana, Albania
                {/* &#x1f1e6; &#x1f1f1; */}
              </small>
            </a>
          </div>
          <p>
            A Master Degree graduate at Faculty of Natural Sciences with an interest in web scraping, big data, software development, database administration and UI/UX Design.
            Skilled and knowledge on client, server side, database and business intelligence.

            I have worked as a Delivery Engineer at Mozenda(Dexi.io brand) worked by analyzing, implementing, developing their requirements and finding the way to accomplish every task given, contributed to the success of the company.
            Now I'm a Frontend Developer at Ikons working on projects using React js and Node. js but my main focus is on front-end technologies.<br />
            I consider myself a motivated, educated and hard-working person, always willing to learn new things and like to challenge myself with multiple technologies.

          </p>
          <a href="#contact" className='btn btn-primary btn-animation'>Let's talk</a>
        </div>
      </div>
    </section>
  );
}
